import { SVGProps } from 'react';

const BellScaleSmallCrossedTrue = (props: SVGProps<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M4.19236 4.52512V7.2498C4.13628 8.62255 2.66667 9.33332 2.66667 9.33332V11.3333H11.3333M13.3333 9.33332C13.3333 9.33332 11.8637 8.62261 11.8076 7.2498V4.52512C11.7444 2.96906 10.1407 1.3353 8.35926 1.33417C6.57777 1.33305 9.42221 1.33305 7.64444 1.3342C6.83307 1.33472 6.05642 1.6753 5.44579 2.19336M9.33332 14C9.19782 14.2027 9.00333 14.3711 8.76933 14.4881C8.53533 14.6051 8.27003 14.6666 7.99999 14.6666C7.72995 14.6666 7.46465 14.6051 7.23065 14.4881C6.99664 14.3711 6.80216 14.2027 6.66666 14M0.66667 0.666686L15.3333 15.3333"
            stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            strokeWidth={1.33333}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export default BellScaleSmallCrossedTrue;
